import { type FC } from 'preact/compat';
import { useState } from 'preact/hooks';

import clsx from 'clsx';

import { addFavorite } from '@/shared/api/user';
import { AnalyticsService } from '@/shared/service/analytics/analytics-service';
import { makeClickFavoriteEvent } from '@/shared/service/analytics/events/click-favorite-event';
import { ButtonVariant } from '@/shared/ui/button/types';
import { Button } from '@/shared/ui/button/ui';

import { ReactComponent as FavoriteIcon } from '@/assets/images/icons/favorite.svg?react';

import s from './index.module.scss';

interface Props {
  className?: string;
  defaultValue: boolean;
  gameKey: string;
}

export const FavoriteToggle: FC<Props> = ({ className, gameKey, defaultValue }) => {
  const [inFavorite, setInFavorite] = useState(defaultValue);

  const handleFavoriteClick = async () => {
    setInFavorite((prev) => !prev);

    const favouritesClickEvent = makeClickFavoriteEvent(gameKey);
    AnalyticsService.send(favouritesClickEvent);

    await addFavorite(gameKey);
  };

  return (
    <Button
      className={clsx(s.toggle, inFavorite && s.active, className)}
      variant={ButtonVariant.secondary}
      onClick={handleFavoriteClick}
      icon={<FavoriteIcon className={s.icon} />}
    />
  );
};
